import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CNInsurance } from '../models/cninsurance';
import { SNItemFactory } from '../models/snitemfactory';
import { BecareService } from './becare.service';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  private static instance: InsuranceService = null;

  constructor(private becare: BecareService, private factory: SNItemFactory) {
  }

  public static getInstance(): InsuranceService {
    return InsuranceService.instance;
  }

  public byCode(code: string): Observable<CNInsurance> {
    return new Observable(observer => {
      this.becare.call('/fr/insurance/code/' + code).subscribe(result => {
        if (result.success === true && result.insurance !== undefined) {
          const insurance: CNInsurance = this.factory.itemFromJson(result.insurance);
          observer.next(insurance);
        } else {
          observer.error('error while searching for drug');
        }
      }, error => {
        observer.error(error);
      });
    });
  }
}
